import React, { memo, useEffect, useMemo } from 'react';

import {
  ListItemText,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  List,
  DialogActions,
  Button,
  ListItemButton,
} from '@mui/material';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import adminMessages from '../../AdminDashboard/messages';
import { selectViewRoleId } from '../../../managers/AuthManager/selectors';
import messages from '../messages';
import commonMessages from '../../common/messages';
import { useRoles } from '../../../hooks/useRoles';
import { LOADING_STATES } from '../../../constants/loading-state.constant';
import RoleListSkeleton from '../../common/skeletons/RoleListSkeleton';

const switchableRoleNames = [
  'GlobalAdmin',
  'ReadOnly',
  'ExternalClub',
  'AllOnboarder',
  'Volunteer',
];

function RoleSelectorDialog({ onRoleChange, onClose }) {
  const intl = useIntl();
  const translatedTexts = useMemo(
    () => ({
      titleTxt: intl.formatMessage(messages.roleSelectTitle),
      hintTxt: intl.formatMessage(messages.roleSelectHint),
      cancelTxt: intl.formatMessage(commonMessages.cancel),
    }),
    [intl],
  );
  const { roles, loadRoles, loadingState } = useRoles();
  const switchableRoles =
    roles?.filter(role => switchableRoleNames.includes(role.roleName)) ?? [];

  const currentRoleId = useSelector(selectViewRoleId);
  const handleRoleChange = role => {
    onRoleChange(role);
    onClose();
  };

  useEffect(() => {
    if (loadingState !== LOADING_STATES.SUCCESS) {
      loadRoles();
    }
  }, [loadRoles, loadingState]);

  return (
    <Dialog open onClose={onClose} aria-labelledby="role-selector-dialog-title">
      <DialogTitle id="role-selector-dialog-title">
        {translatedTexts.titleTxt}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>{translatedTexts.hintTxt}</DialogContentText>
        {loadingState === LOADING_STATES.LOADING ? <RoleListSkeleton /> : null}
        <List>
          {switchableRoles.map(role => (
            <ListItemButton
              onClick={() =>
                handleRoleChange({
                  id: role.id,
                  roleName: role.roleName,
                })
              }
              key={role.id}
              selected={role.id === currentRoleId}
            >
              <ListItemText
                primary={intl.formatMessage(adminMessages[role.roleName])}
                secondary={intl.formatMessage(
                  adminMessages[`${role.roleName}Hint`],
                )}
              />
            </ListItemButton>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{translatedTexts.cancelTxt}</Button>
      </DialogActions>
    </Dialog>
  );
}

export default memo(RoleSelectorDialog);
